export default "__VITE_ASSET__BgVLr2RA__"